export const CHAIN_NAME_ABBR_MAP = {
  dickssportinggoods: 'dsg',
  golfgalaxy: 'gg',
  publiclands: 'pl',
  goinggoinggone: 'g3',
} as const;
